import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { MenuComponent } from './menu/menu.component';
import { HeaderComponent } from './header/header.component';
import { NewsDisplayComponent } from './newsDisplay/news-display.component';

@NgModule({
  imports: [SharedModule],
  declarations: [HeaderComponent, MenuComponent, NewsDisplayComponent],
  exports: [HeaderComponent, MenuComponent],
})
export class LayoutModule {}
